export default {
  title: 'Klub',
  type: 'object',
  properties: {
    name: {
      title: 'schema.club.name',
      type: 'string',
      fieldRequired: true
    },
    phoneNumber: {
      title: 'schema.club.phoneNumber',
      type: 'string',
      fieldRequired: true
    },
    email: {
      title: 'schema.club.email',
      type: 'string',
      format: 'email',
      fieldRequired: true,
      validationMessages: {
        format: 'Niepoprawny adres e-mail.'
      }
    },
    www: {
      title: 'schema.club.www',
      type: 'string',
      fieldRequired: false
    },
    description: {
      title: 'schema.club.description',
      type: 'string',
      fieldRequired: true
    },
    city: {
      title: 'schema.club.city',
      type: 'string',
      fieldRequired: true
    },
    street: {
      title: 'schema.club.street',
      type: 'string',
      fieldRequired: true
    },
    homeNumber: {
      title: 'schema.club.homeNumber',
      type: 'string',
      fieldRequired: false
    },
    localNumber: {
      title: 'schema.club.localNumber',
      type: 'string',
      fieldRequired: false
    },
    postalCode: {
      title: 'schema.club.postalCode',
      type: 'string',
      fieldRequired: false
    },
    terc: {
      title: 'scgema.club.terc',
      type: 'string',
      fieldRequired: false
    },
    woj: {
      title: 'schema.club.woj',
      type: 'string',
      fieldRequired: false
    },
    pow: {
      title: 'schema.club.pow',
      type: 'string',
      fieldRequired: false
    },
    gmi: {
      title: 'schema.club.gmi',
      type: 'string',
      fieldRequired: false
    }
  }
};
